import React from 'react';
import { DiaryEntry } from './DiaryEntry';
export function DiarySection() {
  const entries = [{
    date: 'Vor 6 Monaten',
    title: 'Das Problem',
    content: 'Luna leckt ihre Pfoten stundenlang. Zwischen den Zehen ist die Haut gerötet. Ich denke an Allergien, an Pilze, an Kontaktreizung. Ich kaufe Spezialshampoo. Nichts hilft dauerhaft. Der Tierarzt vermutet Futterallergie – wir wechseln das Futter. Keine Verbesserung.'
  }, {
    date: 'Vor 4 Monaten',
    title: 'Die Entdeckung',
    content: 'Ich lese einen Artikel: Pfotenlecken kann ein Zeichen von Darmproblemen sein. Der Darm-Haut-Achse. Ich bin skeptisch aber fasziniert. Ein gestörter Darm kann sich in Hautreizungen, Juckreiz und Pfotenlecken äußern. Das hat mir niemand erklärt.'
  }, {
    date: 'Vor 10 Wochen',
    title: 'Der Versuch',
    content: 'Ich bestelle ein pflanzliches Futtertopping für den Magen-Darm-Trakt. Nicht für die Haut – für den Darm. Ich bin neugierig. Nach 2 Wochen: Luna leckt seltener. Nach 4 Wochen: die Rötung zwischen den Zehen geht zurück. Ich kann es kaum glauben.'
  }, {
    date: 'Heute',
    title: 'Heute',
    content: 'Luna leckt ihre Pfoten noch gelegentlich – aber nicht mehr obsessiv. Die Haut ist entspannt. Ich habe nie ein Hautprodukt gefunden das half. Die Lösung kam aus dem Darm.'
  }];
  return <section className="w-full py-12 px-4 md:px-8 relative" data-id="element-37">
      {/* Subtle connecting line behind entries */}
      <div className="absolute left-1/2 top-0 bottom-0 w-px bg-warmBrown/10 -translate-x-1/2 hidden md:block" data-id="element-38"></div>

      <div className="max-w-4xl mx-auto" data-id="element-39">
        {entries.map((entry, index) => <DiaryEntry key={index} entryNumber={index + 1} date={entry.date} title={entry.title} content={entry.content} data-id="element-40" />)}
      </div>
    </section>;
}